import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { MapContainer, TileLayer, Marker } from 'react-leaflet';
import { useNavigate } from 'react-router-dom';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { MapPin, Search, X } from 'lucide-react';

const API = (process.env.REACT_APP_BACKEND_URL || '') + '/api';
const CP_COORDS = {"01": [46.2057, 5.2256], "02": [49.5641, 3.6178], "03": [46.5658, 3.3324], "04": [44.0921, 6.2357], "05": [44.5594, 6.0796], "06": [43.7102, 7.262], "07": [44.7349, 4.5994], "08": [49.7719, 4.7197], "09": [42.9637, 1.6045], "10": [48.2973, 4.0744], "11": [43.213, 2.3491], "12": [44.3496, 2.5736], "13": [43.2965, 5.3698], "14": [49.1829, -0.3707], "15": [44.9259, 2.4407], "16": [45.6484, 0.1562], "17": [46.1591, -1.152], "18": [47.081, 2.3987], "19": [45.2671, 1.7714], "20": [42.15, 9.1], "21": [47.322, 5.0415], "22": [48.5141, -2.7653], "23": [46.1714, 1.8714], "24": [45.184, 0.7218], "25": [47.238, 6.0243], "26": [44.9334, 4.8924], "27": [49.027, 1.1508], "28": [48.4439, 1.4895], "29": [47.996, -4.0973], "30": [43.8367, 4.3601], "31": [43.6047, 1.4442], "32": [43.6463, 0.5855], "33": [44.8378, -0.5792], "34": [43.6119, 3.8772], "35": [48.1173, -1.6778], "36": [46.8119, 1.6918], "37": [47.3941, 0.6848], "38": [45.1885, 5.7245], "39": [46.6753, 5.5544], "40": [43.8907, -0.499], "41": [47.5861, 1.3359], "42": [45.4397, 4.3872], "43": [45.043, 3.885], "44": [47.2184, -1.5536], "45": [47.9029, 1.9093], "46": [44.4475, 1.4413], "47": [44.2034, 0.6164], "48": [44.518, 3.5006], "49": [47.4784, -0.5632], "50": [49.1158, -1.089], "51": [48.9566, 4.3637], "52": [48.1117, 5.1389], "53": [48.0698, -0.77], "54": [48.6921, 6.1844], "55": [48.771, 5.1614], "56": [47.6582, -2.7608], "57": [49.1193, 6.1757], "58": [46.9896, 3.157], "59": [50.6292, 3.0573], "60": [49.4295, 2.0809], "61": [48.4306, 0.0915], "62": [50.291, 2.7775], "63": [45.7772, 3.087], "64": [43.2951, -0.3708], "65": [43.2328, 0.0782], "66": [42.6887, 2.8948], "67": [48.5734, 7.7521], "68": [48.0794, 7.3585], "69": [45.764, 4.8357], "70": [47.6216, 6.1556], "71": [46.3069, 4.8286], "72": [48.0061, 0.1996], "73": [45.5646, 5.9178], "74": [45.8992, 6.1294], "75": [48.8566, 2.3522], "76": [49.4432, 1.0993], "77": [48.5421, 2.6601], "78": [48.8014, 2.1301], "79": [46.3239, -0.4646], "80": [49.8941, 2.2958], "81": [43.9298, 2.148], "82": [44.0181, 1.355], "83": [43.1242, 5.928], "84": [43.9493, 4.8055], "85": [46.6705, -1.4269], "86": [46.5802, 0.3404], "87": [45.8336, 1.2611], "88": [48.1744, 6.4513], "89": [47.7982, 3.5734], "90": [47.6379, 6.8628], "91": [48.6238, 2.429], "92": [48.8924, 2.2069], "93": [48.9106, 2.4397], "94": [48.7904, 2.4556], "95": [49.0518, 2.0938], "97": [16.265, -61.551]};
const DEP_NOMS = {"01": "Ain", "02": "Aisne", "03": "Allier", "04": "Alpes-de-Haute-Provence", "05": "Hautes-Alpes", "06": "Alpes-Maritimes", "07": "Ardèche", "08": "Ardennes", "09": "Ariège", "10": "Aube", "11": "Aude", "12": "Aveyron", "13": "Bouches-du-Rhône", "14": "Calvados", "15": "Cantal", "16": "Charente", "17": "Charente-Maritime", "18": "Cher", "19": "Corrèze", "20": "Corse", "21": "Côte-d'Or", "22": "Côtes-d'Armor", "23": "Creuse", "24": "Dordogne", "25": "Doubs", "26": "Drôme", "27": "Eure", "28": "Eure-et-Loir", "29": "Finistère", "30": "Gard", "31": "Haute-Garonne", "32": "Gers", "33": "Gironde", "34": "Hérault", "35": "Ille-et-Vilaine", "36": "Indre", "37": "Indre-et-Loire", "38": "Isère", "39": "Jura", "40": "Landes", "41": "Loir-et-Cher", "42": "Loire", "43": "Haute-Loire", "44": "Loire-Atlantique", "45": "Loiret", "46": "Lot", "47": "Lot-et-Garonne", "48": "Lozère", "49": "Maine-et-Loire", "50": "Manche", "51": "Marne", "52": "Haute-Marne", "53": "Mayenne", "54": "Meurthe-et-Moselle", "55": "Meuse", "56": "Morbihan", "57": "Moselle", "58": "Nièvre", "59": "Nord", "60": "Oise", "61": "Orne", "62": "Pas-de-Calais", "63": "Puy-de-Dôme", "64": "Pyrénées-Atlantiques", "65": "Hautes-Pyrénées", "66": "Pyrénées-Orientales", "67": "Bas-Rhin", "68": "Haut-Rhin", "69": "Rhône", "70": "Haute-Saône", "71": "Saône-et-Loire", "72": "Sarthe", "73": "Savoie", "74": "Haute-Savoie", "75": "Paris", "76": "Seine-Maritime", "77": "Seine-et-Marne", "78": "Yvelines", "79": "Deux-Sèvres", "80": "Somme", "81": "Tarn", "82": "Tarn-et-Garonne", "83": "Var", "84": "Vaucluse", "85": "Vendée", "86": "Vienne", "87": "Haute-Vienne", "88": "Vosges", "89": "Yonne", "90": "Territoire de Belfort", "91": "Essonne", "92": "Hauts-de-Seine", "93": "Seine-Saint-Denis", "94": "Val-de-Marne", "95": "Val-d'Oise", "97": "Outre-mer"};

function makeIcon(count) {
  return L.divIcon({
    className: '',
    html:
      '<div style="position:relative;width:46px;height:50px;">' +
        '<div style="position:absolute;left:3px;top:3px;width:40px;height:40px;background:#2F6BEB;border-radius:50% 50% 50% 0;transform:rotate(-45deg);box-shadow:0 0 16px 5px rgba(47,107,235,0.6),0 3px 5px rgba(0,0,0,0.25);"></div>' +
        '<div style="position:absolute;left:11px;top:11px;width:24px;height:24px;background:#ffffff;border-radius:50%;display:flex;align-items:center;justify-content:center;"><b style="color:#1E3A8A;font-size:15px;font-weight:800;font-family:Inter,sans-serif;">' + count + '</b></div>' +
      '</div>',
    iconSize: [46, 50],
    iconAnchor: [23, 50],
    popupAnchor: [0, -30]
  });
}

const norm = (s) => (s || '').toString().toLowerCase();

function deptMatch(d, q) {
  if (!q) return true;
  if (norm(d.name).indexOf(q) >= 0 || d.code.indexOf(q) >= 0) return true;
  return d.items.some((it) => norm(it.nom).indexOf(q) >= 0 || (it.cp || '').indexOf(q) >= 0);
}

const CarteInstallationsCommercial = () => {
  const navigate = useNavigate();
  const [byDept, setByDept] = useState([]);
  const [total, setTotal] = useState(0);
  const [sel, setSel] = useState(null);
  const [gq, setGq] = useState('');
  const [pq, setPq] = useState('');

  useEffect(() => { load(); }, []);

  async function load() {
    try {
      // Carte COMMERCIALE : on ne récupère que les prospects du commercial connecté
      // (/mes-prospects filtre côté serveur sur commercial_assigne_id via le token)
      let arr = [];
      try {
        const r = await axios.get(API + '/mes-prospects', {
          headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
        });
        const tous = Array.isArray(r.data) ? r.data : ((r.data && r.data.data) || []);
        // On garde uniquement les clients installés (2 graphies possibles)
        arr = tous.filter((p) => {
          const s = (p.status || '').toString().trim().toLowerCase();
          return s === 'client installé' || s === 'client installe';
        });
      } catch (e) {}
      const groups = {};
      arr.forEach((p) => {
        const dep = (p.code_postal || '').substring(0, 2);
        if (!groups[dep]) groups[dep] = [];
        groups[dep].push({
          id: p.id,
          nom: ((p.prenom || '') + ' ' + (p.nom || '')).trim(),
          cp: p.code_postal || '',
          produit: p.puissance_installation || 'Panneaux photovoltaïques'
        });
      });
      const list = Object.keys(groups).map((dep) => {
        const c = CP_COORDS[dep] || [46.603354, 1.888334];
        return { code: dep, name: DEP_NOMS[dep] || ('Dép. ' + dep), lat: c[0], lng: c[1], items: groups[dep] };
      });
      setByDept(list);
      setTotal(arr.length);
    } catch (e) {
      console.log('Erreur carte installations:', e);
    }
  }

  function openDept(d) { setSel(d); setPq(gq); }
  function closePanel() { setSel(null); }

  const panelItems = sel ? sel.items.filter((it) => !pq || norm(it.nom).indexOf(norm(pq)) >= 0 || (it.cp || '').indexOf(pq) >= 0) : [];

  return (
    <div className="card" style={{ borderRadius: '16px', overflow: 'hidden' }}>
      <div className="card-header">
        <div className="flex items-center justify-between" style={{ gap: '12px', flexWrap: 'wrap' }}>
          <div className="flex items-center gap-3">
            <MapPin className="w-5 h-5 text-primary" />
            <h2 className="text-lg font-semibold text-gray-900">Carte des installations</h2>
          </div>
          <div className="flex items-center gap-2">
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', border: '1px solid #e5e7eb', borderRadius: '10px', padding: '5px 9px', background: '#fff' }}>
              <Search className="w-4 h-4 text-gray-400" />
              <input value={gq} onChange={(e) => setGq(e.target.value)} placeholder="Rechercher un client..." style={{ border: 'none', outline: 'none', fontSize: '13px', width: '160px' }} />
            </div>
            <span className="px-3 py-1 text-sm font-semibold bg-blue-100 text-blue-600 rounded-full">{total} installations</span>
          </div>
        </div>
      </div>

      <div className="card-body">
        <div style={{ position: 'relative', borderRadius: '16px', overflow: 'hidden', border: '1px solid #e5e7eb', height: '520px' }}>
          <MapContainer
            center={[46.603354, 1.888334]}
            zoom={6}
            minZoom={5}
            maxZoom={8}
            maxBounds={[[41.0, -5.8], [51.5, 9.8]]}
            maxBoundsViscosity={1.0}
            style={{ height: '100%', width: '100%' }}
            scrollWheelZoom={true}
          >
            <TileLayer
              attribution="&copy; OpenStreetMap contributors"
              url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png"
            />
            {byDept.map((d) => (
              <Marker
                key={d.code}
                position={[d.lat, d.lng]}
                icon={makeIcon(d.items.length)}
                opacity={gq && !deptMatch(d, norm(gq)) ? 0.25 : 1}
                eventHandlers={{ click: () => openDept(d) }}
              />
            ))}
          </MapContainer>

          <div style={{ position: 'absolute', top: 0, right: 0, height: '100%', width: '320px', maxWidth: '80%', background: '#fff', borderLeft: '1px solid #e5e7eb', boxShadow: '-8px 0 24px rgba(15,23,42,0.12)', transform: sel ? 'translateX(0)' : 'translateX(105%)', transition: 'transform .25s', zIndex: 1200, display: 'flex', flexDirection: 'column', padding: '14px', boxSizing: 'border-box' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
              <b style={{ fontSize: '14px', color: '#0a1628' }}>{sel ? (sel.name + ' · ' + sel.items.length) : ''}</b>
              <X className="w-5 h-5 text-gray-400" style={{ cursor: 'pointer' }} onClick={closePanel} />
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', border: '1px solid #e5e7eb', borderRadius: '10px', padding: '6px 9px', marginBottom: '10px' }}>
              <Search className="w-4 h-4 text-gray-400" />
              <input value={pq} onChange={(e) => setPq(e.target.value)} placeholder="Filtrer ce département..." style={{ border: 'none', outline: 'none', fontSize: '13px', width: '100%' }} />
            </div>
            <div style={{ overflowY: 'auto', flex: 1 }}>
              {panelItems.length === 0 ? (
                <div style={{ fontSize: '13px', color: '#94a3b8', padding: '10px 0' }}>Aucun client.</div>
              ) : (
                panelItems.map((it) => (
                  <div
                    key={it.id}
                    onClick={() => navigate('/prospects-entrants/' + it.id + '/fiche-rdv')}
                    style={{ display: 'flex', gap: '8px', alignItems: 'flex-start', padding: '9px 4px', borderBottom: '1px solid #eef2f7', cursor: 'pointer', borderRadius: '8px' }}
                    onMouseEnter={(e) => { e.currentTarget.style.background = '#f8fafc'; }}
                    onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; }}
                  >
                    <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#2F6BEB', marginTop: '5px', flexShrink: 0 }}></span>
                    <div>
                      <div style={{ fontSize: '13px', fontWeight: 600, color: '#0a1628' }}>{it.nom}</div>
                      <div style={{ fontSize: '12px', color: '#64748b' }}>{it.cp} · {it.produit}</div>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CarteInstallationsCommercial;
